import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import StickyMobileBar from "./components/feature/StickyMobileBar";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="pb-16 md:pb-0">
          <AppRoutes />
          <StickyMobileBar />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;